.root input::placeholder {
  opacity: 1;
}

.fadedPlaceholder input::placeholder {
  opacity: 0.42;
}

.option {
  font-size: 14px;
}
